import * as yup from 'yup'
import { pt } from 'yup-locale-pt'

yup.setLocale(pt)

const DEFAULT_NAMES = {
  zipCode: 'zip_code',
  street: 'street',
  number: 'number',
  state: 'state',
  city: 'city',
  district: 'district',
  complement: 'complement'
}

export const getValidationSchema = ({
  namePrefix = '',
  names: customNames = {},
  required = true
} = {}) => {
  const names = { ...DEFAULT_NAMES, ...customNames }
  const prefix = namePrefix ? `${namePrefix}.` : ''
  const field = value => `${prefix}${value}`
  const optionalString = yup.string().nullable()
  const requiredString = optionalString.required()

  return yup.object().shape({
    [field(names.zipCode)]: required ? requiredString.label('CEP') : optionalString,
    [field(names.street)]: required
      ? requiredString.label('Rua/Av/Logradouro')
      : optionalString,
    [field(names.number)]: required ? requiredString.label('Numero') : optionalString,
    [field(names.state)]: required ? requiredString.label('UF') : optionalString,
    [field(names.city)]: required ? requiredString.label('Cidade') : optionalString,
    [field(names.district)]: required ? requiredString.label('Bairro') : optionalString,
    [field(names.complement)]: optionalString.label('Complemento')
  })
}
